module.exports = "/_next/static/images/ng-ffd18fe39abc5ad5e8b2fc3f06ed2ca2.svg";